
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import {jcalendar_week} from './styles/script';
import $ from 'jquery';

export default {

data(){
return {
}
},
components: {
Radio, Group, Cell,XTextarea,XButton, PopupRadio
},
methods:{
fun_a(){
return new Promise(function(resolve, reject){
fetch('get','http://192.168.115.99:8080' + urlConfig.OneInvestigationGet+'ff80808162f62ad70162f6adf96f1efb').then(response => {
resolve(1);
}).catch(error => {

})

})
},
fun_b(data_a){
return new  Promise(function (resolve, reject) {
fetch('get','http://192.168.115.99:8080' + urlConfig.OneInvestigationGet+'ff80808162f62ad70162f6adf96f1efb').then(response => {
resolve();
}).catch(error => {

})

});
},
fun_c(data_b){
return new Promise(function(resolve, reject){
fetch('get','http://192.168.115.99:8080' + urlConfig.OneInvestigationGet+'ff80808162f62ad70162f6adf96f1efb').then(response => {
resolve();
}).catch(error => {

})
})
}
},
mounted(){
/*    let _this = this;
this.fun_a().then(function(data){
return _this.fun_b(data);
}).then(function(data){
return _this.fun_c(data)
}).then(function (data) {
console.log(data)
})*/
this.$nextTick(function () {
var weekfn =  new jcalendar_week({
element: "#jcalendar_week",//填充日历的dom元素
dayaddclass:function(date){

return "";
},
dayclick:function(date,obj){

$(obj).addClass("calendar_day_act").siblings().removeClass("calendar_day_act");
$(obj).parents('.calendar_time_barCon>li').siblings().find('li').removeClass("calendar_day_act");
/* console.log(weekfn.getdataandtime(obj))*/
}
});
})


}
}



// WEBPACK FOOTER //
// ./src/components/bbbbbb.vue